module.exports = __webpack_public_path__ + "img/Instagram_white.13709e84.svg";